/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Trans} from "react-i18next";

export const VideoModalBody = (props) => {
  console.log(props);
  return (
    <>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          title="unique"
          className="embed-responsive-item"
          src={`${props.frameCode}?color=ffffff&title=0&byline=0&portrait=0`}
          allow="autoplay; fullscreen"
          allowFullScreen
        ></iframe>
      </div>
      <div className="videoAreaTitle my-3">
        <span>{props.subject}</span>
      </div>
      <div className="videoAreaDesc">{props.detail}</div>
    </>
  );
};

export const VideoModalFooter = (props) => {
  const handleNavigation = (newIdx) => {
    if (newIdx < 0) {
      props.selectAnnouncement(0);
    } else {
      props.selectAnnouncement(newIdx);
    }
  };
  return (
    <>
      <button
        className="btn btn-video float-left"
        data-dismiss="modal"
        onClick={() => handleNavigation(props.idx - 1)}
      >
        <span className="icon-icon-detail mr-2 left"></span> <Trans desc="Önceki Video">10378</Trans>
      </button>
      <button
        onClick={() => handleNavigation(props.idx + 1)}
        className="btn btn-video float-right"
        data-dismiss="modal"
      >
        <Trans desc="Sonraki Video">10379</Trans> <span className="icon-icon-detail ml-2"></span>
      </button>
    </>
  );
};
